import '../css/main.css';
import 'virtual:auto-styles';
import 'virtual:auto-scripts';
import 'fslightbox';

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'


// Make Alpine available globally
window.Alpine = Alpine

// Helpers (must be loaded before Alpine.start())
import './helpers/load-more-posts.js';
import './helpers/reveal.js';
import './helpers/smart-header.js';

// Start Alpine
Alpine.plugin(collapse)
Alpine.start()


